// import { faker } from '@faker-js/faker';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box,  Paper, Button, Typography, CardContent } from '@mui/material';
// utils
//
import { varFadeInRight,  varBounceInUp, MotionContainer } from '../../../components/animate';
import { CarouselControlsArrowsIndex } from '../../../components/carousel/controls';


// redux
import { useDispatch, useSelector } from '../../../redux/store';

// data
import { getBanners } from '../../../redux/slices/home';

// ----------------------------------------------------------------------

const CarouselImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

const CarouseSublImgStyle =styled('img')(({ theme }) => ({
  right: 100,
  top: 30,
  height: '100%',
  objectFit: 'scale-down',
  position: 'absolute',
  [theme.breakpoints.down(480)]: {
    right: 5,
    top: 100,
    height: '80%',
   
  },
}));

const Styledtext = styled(Typography)({
  height: 104,
  width: '100',
  overflow: 'hidden',
  WebkitLineClamp: 4,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});
// ----------------------------------------------------------------------

// const CAROUSELS = [...Array(5)].map((_, index) => {
//   const setIndex = index + 1;
//   return {
//     title: faker.company.name(),
//     description: faker.lorem.paragraphs(),
//     smimage: `/assets/images/asap/banner_person_01.png`,
//     image: `/assets/images/covers/cover_${setIndex}.jpg`,
//   };
// });

CarouselItem.propTypes = {
  item: PropTypes.object,
  isActive: PropTypes.bool,
};

function CarouselItem({ item, isActive }) {
  const theme = useTheme();
  const { image, title,body, smimage, url } = item;

  return (
    <Paper
      sx={{
        position: 'relative',
        paddingTop: { xs: '100%', md: '35%' },
      }}
    >
      <CarouselImgStyle alt={title} src={image} />
      <Box
        sx={{
          top: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          backgroundImage: `linear-gradient(to top, ${theme.palette.grey[900]} 0%,${alpha(
            theme.palette.grey[900],
            0
          )} 100%)`,
        }}
      />
      <CardContent
        sx={{
          top: {xs:10, md:50},
          width: '100%',
          maxWidth: 480,
          textAlign: 'left',
          position: 'absolute',
          color: 'common.white',
        }}
      >
        <MotionContainer open={isActive}>
          <motion.div variants={varFadeInRight}>
            <Typography variant="h3" gutterBottom>
              {item.title}
            </Typography>
          </motion.div>
          <motion.div variants={varFadeInRight}>
            <Styledtext variant="body2" gutterBottom>
              {body}
            </Styledtext>
          </motion.div>
          <motion.div variants={varFadeInRight}>
            <Button to={url} component={RouterLink} variant="contained" sx={{ mt: 3 }}>
              View More
            </Button>
          </motion.div>
        </MotionContainer>
      </CardContent>
      <MotionContainer open={isActive}>
      <motion.div variants={varBounceInUp} transition={{delay:600}} >
      <CarouseSublImgStyle alt={title} src={smimage} />
      </motion.div>
      </MotionContainer>
    </Paper>
  );
}

export default function HeroWidget() {
  const theme = useTheme();

  const dispatch = useDispatch();
  const carouselRef = useRef();
  const { banners, error, isLoading } = useSelector((state) => state.home);
  

  useEffect(() => {
    dispatch(getBanners());
  }, [dispatch]);

  const [currentIndex, setCurrentIndex] = useState(theme.direction === 'rtl' ? banners? banners.length - 1 : 0:0);

 
  
 
  const settings = {
    speed: 800,
    dots: false,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    beforeChange: (current, next) => setCurrentIndex(next),
  };

  const handlePrevious = () => {
    carouselRef.current.slickPrev();
  };

  const handleNext = () => {
    carouselRef.current.slickNext();
  };

  return (
    <>
      <Slider ref={carouselRef} {...settings}>
        {banners.map((item, index) => (
          <CarouselItem key={item.id} item={item} isActive={index === currentIndex} />
        ))}
      </Slider>

      <CarouselControlsArrowsIndex
        index={currentIndex}
        total={banners.length}
        onNext={handleNext}
        onPrevious={handlePrevious}
        sx={{ bottom: theme.spacing(25),}}
     
      />
    </>
  );
}
